import type { ComponentNameAndModule } from '@sitecore-jss/sitecore-jss-angular';

const loadChildren = () =>
  import('./feh-homebattery.lazy.module').then(
    (module) => module.FehHomebatteryLazyModule
  );

export const fehHomebatteryLazyImports: ComponentNameAndModule[] = [
  {
    path: 'HomeBatteryWizard',
    loadChildren,
  },
  {
    path: 'HomebatteryAdviceForm',
    loadChildren,
  },
  {
    path: 'HomeBatteryQuestionnaire',
    loadChildren,
  },
  {
    path: 'HomeBatteryOrderForm',
    loadChildren,
  },
  {
    path: 'HomeBatteryCapacityAdvice',
    loadChildren,
  },
];
